<template>
    <div class="buyflow-panel grid grid-cols-12 gap-x-4 gap-y-2 items-center">
        <div class="col-span-12 desktop:col-span-9">
            <div class="flex items-center font-bold mb-1 text-center desktop:text-left">
                <IconWifi class="text-navy-dark mr-1 flex-shrink-0" />
                Add even more WiFi Pods
            </div>
            <div class="text-sm text-left">
                Homes larger than 2400 sq/ft should consider adding additional WiFi Pods to cover their entire home.
            </div>
        </div>
        <div class="flex items-center gap-x-4 justify-center desktop:justify-around col-span-12 desktop:col-span-3 desktop:col-start-10">
            <div class="block leading-none desktop:text-center">
                <span class="text-navy-dark font-bold -mx-1">
                    {{ toCurrency(quantity > 0 ? (quantity * price) : price) }}
                </span>
                <span class="text-xs">
                    <template v-if="quantity > 0">
                        /mo.
                    </template>
                    <template v-else>
                        /mo. each
                    </template>
                </span>
            </div>
            <div
                class="buyflow-numeric-select"
                :class="{ 'active': quantity > 0 }"
            >
                    <select
                        v-model="quantity"
                        @change="quantityChanged"
                        class="edge"
                        data-cy="offer-wifi-pods"
                        aria-label="Offer Wifi Pods"
                    >
                        <option :value="0">0</option>
                        <option v-for="n in max"
                                :key="n"
                                :value="n">
                            {{ n }}
                        </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>

    import IconWifi from "@/atoms/icons/IconWifi"

    export default {
        name: 'InternetEquipments_ExtraPods',
        components: {
            IconWifi,
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            decision:{
                type: String,
                required: true,
            },
            price: {
                type: Number,
                required: true,
                default: 4.99,
            },
            max: {
                type: Number,
                required: true,
                default: 5,
            },
            inCart: {
                type: Number,
                default: 0,
            },
        },
        data: () => ({
            quantity: 0,
        }),
        mounted() {
            this.quantity = this.inCart
        },
        methods: {
            quantityChanged() {
                this.$emit('select-options', {
                    pods: {
                        decision: this.decision,
                        selection: {
                            name: this.name,
                            price: this.price,
                            max: this.max,
                        },
                        quantity: this.quantity,
                    }
                })
            },
        },
    }
</script>
